import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { HotspotTable } from './HotspotTable';
import { activateLoading, deactivateLoading } from 'GeminiViewerComponent/features/globals/loadingProgressSlice';
import {
    fetchAllHotspotIcons,
    selectAllHotspots,
    getHotspotStatus,
    getHotspotPageInfo,
    setHotspotRefreshFlag,
} from 'shared/hotspotsSlice';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';

const HotspotManagementTab = () => {
    const dispatch = useDispatch();
    const ref = useRef(false);
    const hotspots = useSelector(selectAllHotspots);
    const hotspotStatus = useSelector(getHotspotStatus);
    const pageInfo = useSelector(getHotspotPageInfo);
    const [sortBy, setSortBy] = useState('display_name');
    const [sortDirection, setSortDirection] = useState('ASC');
    const [hotspotPayload, setHotspotPayload] = useState({
        sort: `${sortDirection === 'ASC' ? '' : '-'}${sortBy}`,
    });

    const getHotspotData = async (payload) => {
        dispatch(activateLoading());
        await dispatch(fetchAllHotspotIcons({ ...payload }));
        dispatch(deactivateLoading());
    };

    useEffect(() => {
        if (ref.current === true) {
            getHotspotData({ ...hotspotPayload });
        }
        return () => {
            dispatch(setHotspotRefreshFlag());
        };
    }, [hotspotPayload]);

    useEffect(() => {
        if (hotspotStatus === LoadingStatus.Idle) {
            getHotspotData({ ...hotspotPayload });
        }
        ref.current = true;
    }, [hotspotStatus]);

    const setSorting = (_sortBy, _sortDirection) => {
        setSortBy(_sortBy);
        setSortDirection(_sortDirection);
        if (
            _sortBy === 'is_default' ||
            _sortBy === 'is_highlight' ||
            _sortBy === 'is_populated' ||
            _sortBy === 'is_unpopulated'
        ) {
            _sortDirection = _sortDirection === 'ASC' ? 'DESC' : 'ASC';
        }
        setHotspotPayload({
            ...hotspotPayload,
            sort: `${_sortDirection === 'ASC' ? '' : '-'}${_sortBy}`,
        });
    };

    return (
        <HotspotTable
            hotspots={hotspots}
            pageInfo={pageInfo}
            hotspotPayload={hotspotPayload}
            setHotspotPayload={setHotspotPayload}
            sortDirection={sortDirection}
            sortBy={sortBy}
            handleSort={(_sortBy, _sortDirection) => setSorting(_sortBy, _sortDirection)}
        />
    );
};

export { HotspotManagementTab };
